import { concatUrlPath } from '~/utils';

/** Share UTMs required by the task; `content` is filled with the agent slug. */
export const AGENT_PROFILE_SHARE_UTM = {
	source: 'shared',
	medium: 'share',
	campaign: 'pagina_corretor'
} as const;

/**
 * Builds the public agent profile URL with the share UTMs. The button behaviour
 * itself comes from `usePropertyHeroShare`.
 *
 * Assembled by string concatenation rather than `new URL`, which throws on a
 * relative input: `ORIGIN` has no fallback in the runtime config, so an empty
 * one would take down the whole hero — the value is read while rendering, not
 * on click. This mirrors how `usePropertyHeroShare` builds its own URL.
 *
 * @param origin - Public app origin (`ORIGIN` from the runtime config)
 * @param slug - Agent slug
 * @returns The URL with UTMs, or an empty string while the slug is missing
 */
export function buildAgentProfileShareUrl(
	origin: string,
	slug: string | null | undefined
): string {
	if (!slug) return '';

	const path = concatUrlPath(origin, `/corretor/${encodeURIComponent(slug)}`);

	const params = new URLSearchParams({
		utm_source: AGENT_PROFILE_SHARE_UTM.source,
		utm_medium: AGENT_PROFILE_SHARE_UTM.medium,
		utm_campaign: AGENT_PROFILE_SHARE_UTM.campaign,
		utm_content: slug
	});

	return `${path}?${params.toString()}`;
}
